import React, { Fragment, useMemo } from 'react'
import { getVal, toArray } from 'oolib'
import { formatters } from '../../cards/TableElem/CONFIG_PARSER/TableCellBlocks/utils/formatters'
import { TagDisplay } from 'oolib/dist/v2/components/Tags'

const Tags__Intro = ({
  content: _content,
  value,
  
  XS,
  S = true,
  M,
  /**
   * we are trying to move to a situation where 
   * valuepath is never passed thru, its always null.
   * and this comp simply expects the value and it does the work
   * of rendering it.
   * 
   * hence we keep the valuePath with the default value of null,
   * cuz that ensure that the value (content) is considered as is.
   */
  valuePath = null, 
  style = {},
  invert,
  align='center',
  flexWrap='wrap',
  formatter,
  Wrapper = 'div',
  colorPresetLookup,
  colorPreset: _colorPreset

}) => {

  let content = _content || value

  // Memoize the initial processing of items config
  const items = useMemo(() => {
    let processedItems = valuePath !== undefined
      ? toArray(getVal(content, valuePath)).filter(d => d !== null && d !== undefined)
      : [];

    // Convert simple values to {display, value} format
    if(processedItems.every(d => ['string', 'number', 'boolean'].indexOf(typeof d) !== -1)){
      processedItems = processedItems.map(d => ({
        display: (typeof d === 'string' && formatter)
          ? formatters[formatter](d)
          : d, 
        value: d
      }))
    }

    // Normalize tag data structure
    if(processedItems.every(d => d._id && d.display)){
      processedItems = processedItems.map(d => ({
        display: d.display,
        value: d._id
      }))
    }

    // Validate structure
    if(processedItems.some(item => !item?.display || !item?.value)){
      processedItems = []
    }

    return processedItems;
  }, [content, valuePath, formatter]);

  // Memoize container styles
  const containerStyles = useMemo(() => ({
    ...style, 
    justifyContent: align === 'center' ? 'center' : 'flex-start',
    display: 'flex',
    flexWrap,
    gap: '4px' // Add some spacing between tags
  }), [style, align]);

  // Early return if no items
  if (valuePath !== undefined && (!items || items.length === 0)) {
    return null;
  }

  return (
    <Fragment>
      {valuePath !== undefined && items?.length > 0 && (
        <Wrapper style={{width: '100%', overflow: 'hidden'}}>
          <div 
            className="introTags" 
            style={containerStyles}
            title={items.map(i => i.display).join(', ')}
          >
            {items.map((item) => {
              const colorPreset = (!_colorPreset && !colorPresetLookup)
                ? undefined
                : _colorPreset || colorPresetLookup[item.value];
                
              return (  
                <div 
                  key={item.value}
                  style={{ flexShrink: 0 }}
                >
                  <TagDisplay display={item.display} colorPreset={colorPreset}/>
                </div>
              );
            })}
          </div>
        </Wrapper>
      )}
    </Fragment>
  )
}

export default React.memo(Tags__Intro);